module.exports = __webpack_public_path__ + "static/media/default.78034061.png";